/**
 *
 * Styles for OfferPriceAndPaymentInfo
 *
 */

import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { Headline } from "root/libs/ui-components/src";
import { DhlText } from "@dhl-official/react-library";

export const CardPriceHeadline = styled(Headline)`
  margin: ${(props) => props.bottomMargin};
  font-size: var(--gaq-size-font-39px) !important;
  line-height: 43px !important;

  @media screen and (min-width: ${breakpoints.tablet}) {
    font-size: var(--gaq-size-font-27px) !important;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    font-size: var(--dui-size-font-5xl) !important;
  }
`;

export const CardPriceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &.has-euro-price {
    gap: 5px;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    align-items: center;
  }

  @media print {
    width: 30%;
  }

  .price-label {
    color: var(--dui-color-black-500);
    margin: var(--dui-size-space-5x) 0;

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-bottom: var(--gaq-size-space-3px);
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      margin-bottom: 0;
    }
  }
`;

export const CardButtonWrapper = styled.div`
  margin-bottom: var(--gaq-size-space-5px);

  button {
    width: 100%;
  }

  @media print {
    display: none;
  }
`;

export const DisclaimerStar = styled.span`
  font-weight: 200;
`;

export const ConversionFactorText = styled(DhlText)`
  margin-top: var(--dui-size-space-1);

  @media screen and (max-width: ${breakpoints.tablet}) {
    margin-bottom: var(--dui-size-space-4x);
  }
`;
